<ng-container *ngIf="isAccountMenu || primaryNavItems">
  <div class="container-fluid position-relative bg-light d-flex my-0" [class.bl-min-h-8]="!primaryNavItems">
    <div class="content-box d-flex flex-column my-1" *ngIf="primaryNavItems?.length">
      <ng-container *ngFor="let navLink of primaryNavItems">
        <button
          *ngIf="isAccountMenu || navLink.childList?.length; else primaryNavLink"
          (click)="onMenuSelect(navLink)"
          shrdUicButton
          variant="headerNav"
          class="d-block my-1"
          [class.active]="navLink.active"
          [shrdUtcTrackEvent]="
            isAccountMenu
              ? null
              : { category: 'SiteOperations', action: 'MainNavigation', label: navLink.title + '|L1' }
          "
        >
          <span>{{ navLink.title }}</span>
        </button>
        <ng-template #primaryNavLink>
          <a
            *ngIf="navLink.url"
            shrdUicButton
            variant="headerNav"
            [href]="navLink.url"
            class="d-flex my-1"
            [class.active]="navLink.active"
          >
            <span>{{ navLink.title }}</span>
          </a>
        </ng-template>
      </ng-container>
    </div>
    <shrd-uic-preloader [active]="!primaryNavItems" immediate size="small"></shrd-uic-preloader>
  </div>
  <hr shrdUicHr vAlign="top" [lineHeight]="1" />
</ng-container>

<div class="container-fluid mt-1 pb-1">
  <div class="content-box">
    <shrd-pf-ft-header-registration-button
      *ngIf="isAccountMenu"
      [userData]="userData"
      buttonVariant="tertiaryMinorBorderlessNeutralDark"
    />
    <shrd-pf-ui-meta-nav
      className="d-block w-100 text-start my-0"
      [metaNavItems]="metaNavItems"
      (menuSelected)="onMenuSelect($event)"
    ></shrd-pf-ui-meta-nav>
    <shrd-pf-ft-header-user-logout
      *ngIf="logoutConfig"
      buttonClasses="m-0 w-100"
      buttonVariant="tertiaryMinorBorderlessNeutralDark"
      [logoutConfig]="logoutConfig"
    >
      <span>{{ 'header.account.logout' | i18next }}</span>
    </shrd-pf-ft-header-user-logout>
  </div>
</div>
